import { useState } from 'react'
import { Search, Loader, X, Home } from 'lucide-react'
import CountryFilter from './CountryFilter'
import { useLanguage } from '../context/LanguageContext'
import './SearchBar.css'

export default function SearchBar({ onSearch, loading, analysisType, setAnalysisType, hasResults, onClear, selectedCountries, onCountriesChange }) {
  const { t } = useLanguage()
  const [query, setQuery] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (query.trim()) {
      onSearch(query, selectedCountries)
    }
  }

  const handleClear = () => {
    setQuery('')
    onClear?.()
  }

  return (
    <div className="w-full space-y-2">
      {/* Top row: tipo de análisis + botón inicio */}
      <div className="flex gap-3 items-center flex-wrap justify-between">
        <div className="flex gap-3 items-center flex-wrap">
          <span className="text-xs text-[#94a3b8] font-light">{t('dashboard.analysisType')}</span>
          <div className="flex gap-2 items-center">
            <button
              onClick={() => setAnalysisType('PRODUCT')}
              className={`type-btn${analysisType === 'PRODUCT' ? ' selected' : ''}`}
            >
              {t('dashboard.products')}
            </button>
            <button
              onClick={() => setAnalysisType('SERVICE')}
              className={`type-btn${analysisType === 'SERVICE' ? ' selected' : ''}`}
            >
              {t('dashboard.services')}
            </button>
            <CountryFilter
              selectedCountries={selectedCountries}
              onCountriesChange={onCountriesChange}
            />
          </div>
        </div>

        {/* Botón de inicio — visible solo cuando hay resultados */}
        {hasResults && (
          <button
            onClick={handleClear}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg text-xs text-[#94a3b8] hover:border-[#4a4a4a] hover:text-[#94a3b8]er transition-all"
            title={t('dashboard.home')}
          >
            <Home className="w-3.5 h-3.5" />
            {t('dashboard.home')}
          </button>
        )}
      </div>

      {/* Buscador */}
      <form onSubmit={handleSubmit} className="relative max-w-2xl">
        <div className="relative">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={
              analysisType === 'PRODUCT'
                ? t('dashboard.searchPlaceholder')
                : t('dashboard.searchPlaceholderService')
            }
            className="w-full px-4 py-2.5 pr-20 bg-slate-darker border border-slate-dark/40 rounded-lg text-sm text-[#94a3b8]est placeholder-slate-light focus:outline-none focus:border-slate-dark focus:ring-2 focus:ring-slate-dark/30 transition-all font-light"
            disabled={loading}
          />

          {/* X para limpiar texto — solo cuando hay texto escrito */}
          {query && !loading && (
            <button
              type="button"
              onClick={handleClear}
              className="absolute right-10 top-1/2 -translate-y-1/2 p-1 text-slate-medium hover:text-[#94a3b8]er transition-colors"
              title="Limpiar búsqueda"
            >
              <X className="w-4 h-4" />
            </button>
          )}

          {/* Botón buscar */}
          <button
            type="submit"
            disabled={loading || !query.trim()}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 bg-gradient-to-r from-slate-dark to-slate-darker rounded-md hover:shadow-lg hover:shadow-slate-dark/40 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            {loading ? (
              <Loader className="w-4 h-4 animate-spin text-white" />
            ) : (
              <Search className="w-4 h-4 text-white" />
            )}
          </button>
        </div>
      </form>
    </div>
  )
}
